module.exports = __webpack_public_path__ + "static/media/Success.96062d5c.svg";